"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileTable = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const table_field_1 = require("../../components/table-field/table-field");
const file_table_toolbar_1 = require("./file-table-toolbar");
const file_table_action_cell_1 = require("./file-table-action-cell");
const file_table_context_1 = require("./file-table-context");
const table_field_cells_1 = require("../../components/table-field/table-field-cells");
function FileTable({ value, onChange, disabled = false, maxItems, }) {
    const intl = react_intl_1.useIntl();
    const columns = [
        {
            name: intl.formatMessage({
                id: 'EAS_FILE_TABLE_COLUMN_ACTIONS',
                defaultMessage: 'Akce',
            }),
            datakey: 'id',
            width: 100,
            CellComponent: file_table_action_cell_1.FileTableActionCell,
        },
        {
            name: intl.formatMessage({
                id: 'EAS_FILE_TABLE_COLUMN_NAME',
                defaultMessage: 'Název',
            }),
            datakey: 'name',
            width: 400,
        },
        {
            name: intl.formatMessage({
                id: 'EAS_FILE_TABLE_COLUMN_CREATED',
                defaultMessage: 'Nahráno',
            }),
            datakey: 'created',
            width: 200,
            CellComponent: table_field_cells_1.TableFieldCells.DateTimeCell,
        },
    ];
    const context = react_1.useMemo(() => ({ maxItems }), [maxItems]);
    return (react_1.default.createElement(file_table_context_1.FileTableContext.Provider, { value: context },
        react_1.default.createElement(table_field_1.TableField, { maxRows: 4, showRadioCond: () => false, showDetailBtnCond: () => false, ToolbarComponent: file_table_toolbar_1.FileTableToolbar, value: value, columns: columns, onChange: onChange, disabled: disabled })));
}
exports.FileTable = FileTable;
//# sourceMappingURL=file-table.js.map